"use client";

import Image from "next/image";
import { useState, useEffect } from "react";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as TSwiper } from "swiper/types";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "@/styles/common/swiper.scss";
import "@/app/reviews/components/video-image-slider/reviewslider.scss";

import PaginationLeft from "@/public/svg/paginarition-arrow-left.svg";
import PaginationRight from "@/public/svg/paginarition-arrow-right.svg";
import Redirect from "@/public/svg/redirect.svg";
import Title from "@/components/title/Title";
import imageData from "@/public/review-data/imageData";

const ReviewSlider = () => {
    const totalSlides = imageData.videoData.length;
    const [activeSlide, setActiveSlide] = useState(1);

    const updatePagination = (swiper: TSwiper) => {
        setActiveSlide(swiper.realIndex + 1);
    };

    useEffect(() => {
        const checkNavButtons = setInterval(() => {
            const prevButton = document.querySelector(".pagination-left");
            const nextButton = document.querySelector(".pagination-right");
            if (prevButton && nextButton) {
                clearInterval(checkNavButtons);
            }
        }, 100);
        return () => clearInterval(checkNavButtons);
    }, []);

    return (
        <section className="popular-destinations-section py-10 md:py-20" id="popularDestinations">
            <div className="popular-destinations-container container px-4 flex flex-col mx-auto gap-6 sm:gap-14">
                <Title title="Unforgettable Experiences, Told by Our Guests" />
                <div className="popular-destinations-slider">
                    <Swiper
                        spaceBetween={24}
                        slidesPerView={1}
                        navigation={{
                            nextEl: ".pagination-right",
                            prevEl: ".pagination-left",
                            enabled: true,
                        }}
                        modules={[Navigation, Autoplay]}
                        autoplay={{
                            delay: 3000,
                            waitForTransition: true,
                        }}
                        loop={true}
                        breakpoints={{
                            639: { slidesPerView: 2 },
                            767: { slidesPerView: 3 },
                            1023: { slidesPerView: 4 },
                            1279: { slidesPerView: 4 },
                        }}
                        className="destinations-swiper"
                        onSlideChange={updatePagination}
                    >
                        {imageData.videoData.map((videoData, index) => (
                            <SwiperSlide key={index} className="destinations-slide">
                                {videoData.path ?
                                <Link href={videoData?.path} className="inline-flex flex-col align-middle gap-6 h-control" target="_blank">
                                    <figure>
                                        <Image
                                            loading="lazy"
                                            className="picture b-r-14"
                                            src={videoData.image}
                                            sizes="(max-width:768px) 100vw, (max-width: 1200px) 25vw, 20vw"
                                            alt="review"
                                        />
                                        {videoData?.path && (
                                            <Image
                                                loading="lazy"
                                                src={Redirect}
                                                alt="Redirect"
                                                className="redirect"
                                                width={36}
                                                height={36}
                                            />
                                        )}
                                    </figure>
                                </Link> : 
                                <figure className="h-control">
                                <Image
                                    loading="lazy"
                                    className="picture b-r-14"
                                    src={videoData.image}
                                    sizes="(max-width:768px) 100vw, (max-width: 1200px) 25vw, 20vw"
                                    alt="review"
                                />
                                {videoData?.path && (
                                    <Image
                                        loading="lazy"
                                        src={Redirect}
                                        alt="Redirect"
                                        className="redirect"
                                        width={36}
                                        height={36}
                                    />
                                )}
                            </figure>}
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className="swiper-pagination-wrapper flex items-center justify-end gap-2 mt-4 sm:mt-10">
                        <div className="pagination-progress flex items-center gap-4">
                            <span className="font-semibold">{activeSlide}/{totalSlides}</span>
                            <div className="progress">
                                <div
                                    className="done"
                                    style={{ width: `${(activeSlide / totalSlides) * 100}%` }}
                                />
                            </div>
                        </div>
                        <div className="pagination-arrows flex items-center gap-3 sm:gap-4">
                            <figure className="pagination-left flex-center">
                                <Image loading="lazy" src={PaginationLeft} alt="Pagination Left" />
                            </figure>
                            <figure className="pagination-right flex-center">
                                <Image loading="lazy" src={PaginationRight} alt="Pagination Right" />
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ReviewSlider;
